import { library } from '@fortawesome/fontawesome-svg-core';

// Solid icons
import {
  faUtensils,
  faCoffee,
  faCheck,
  faUser,
  faEnvelope,
  faPhone,
  faMapMarkerAlt,
  faCartShopping,
  faClipboardList,
  faSearch,
  faPlus,
  faMinus,
  faMinusCircle,
  faPlusCircle,
  faEllipsisH,
  faSpinner,
  faClock,
  faMapMarker,
  faCommentDots,
  faXmark,                 // renamed from faTimes
  faChevronUp,
  faChevronDown,
  faCircleArrowUp,
  faArrowLeft,             // new
  faChevronLeft,           // new
  faChevronRight,          // new
  faTriangleExclamation,   // new
  faCircleCheck,           // new
  faStar                   // new
} from '@fortawesome/free-solid-svg-icons';

import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

// Add all icons to the global library (only once)
library.add(
  faUtensils,
  faCoffee,
  faCheck,
  faUser,
  faEnvelope,
  faPhone,
  faMapMarkerAlt,
  faCartShopping,
  faClipboardList,
  faSearch,
  faPlus,
  faMinus,
  faMinusCircle,
  faPlusCircle,
  faEllipsisH,
  faSpinner,
  faClock,
  faMapMarker,
  faCommentDots,
  faXmark,
  faChevronUp,
  faChevronDown,
  faCircleArrowUp,
  faArrowLeft,
  faChevronLeft,
  faChevronRight,
  faTriangleExclamation,
  faCircleCheck,
  faStar,
  faWhatsapp
);

// Re-export them so you can easily import in any component
export {
  faUtensils,
  faCoffee,
  faCheck,
  faUser,
  faEnvelope,
  faPhone,
  faMapMarkerAlt,
  faCartShopping,
  faClipboardList,
  faSearch,
  faPlus,
  faMinus,
  faMinusCircle,
  faPlusCircle,
  faEllipsisH,
  faSpinner,
  faClock,
  faMapMarker,
  faCommentDots,
  faXmark,
  faChevronUp,
  faChevronDown,
  faCircleArrowUp,
  faArrowLeft,
  faChevronLeft,
  faChevronRight,
  faTriangleExclamation,
  faCircleCheck,
  faStar,
  faWhatsapp
};
